var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "visualization-layout" },
    [
      _c(
        "div",
        { staticClass: "page-parts-container" },
        [
          _c(
            "draggable",
            {
              staticClass: "page-parts-list",
              attrs: {
                animation: 150,
                "ghost-class": "ghost",
                disabled: _vm.isRevision
              },
              on: { start: _vm.pagePartDragStart, end: _vm.pagePartDragEnd },
              model: {
                value: _vm.localPageParts,
                callback: function($$v) {
                  _vm.localPageParts = $$v
                },
                expression: "localPageParts"
              }
            },
            _vm._l(_vm.localPageParts, function(pagePart) {
              return _c(
                "div",
                {
                  key: pagePart.id,
                  staticClass: "page-part",
                  class: { dragging: _vm.isDragging }
                },
                [
                  _c(
                    "div",
                    { staticClass: "page-part-header" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "page-part-title",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.getPagePartLanguageName(pagePart))
                            )
                          ]),
                          _c("span", { staticClass: "block-type" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(_vm.getBlockTypeKey(pagePart.blockType))
                              )
                            )
                          ]),
                          _c("el-button", {
                            attrs: {
                              type: "text",
                              icon: "el-icon-edit",
                              disabled: _vm.isRevision
                            },
                            on: {
                              click: function($event) {
                                return _vm.handlePagePartConfig(pagePart)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-button", {
                        attrs: {
                          type: "text",
                          icon: "el-icon-close",
                          disabled: _vm.isRevision
                        },
                        on: {
                          click: function($event) {
                            return _vm.removePagePart(pagePart)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "elements-container" },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "elements-grid",
                          attrs: {
                            animation: 150,
                            "ghost-class": "element-ghost",
                            group: "elements",
                            disabled: _vm.isRevision
                          },
                          on: {
                            start: function($event) {
                              return _vm.elementDragStart($event, pagePart)
                            },
                            end: function($event) {
                              return _vm.elementDragEnd($event, pagePart)
                            }
                          },
                          model: {
                            value: pagePart.elements,
                            callback: function($$v) {
                              _vm.$set(pagePart, "elements", $$v)
                            },
                            expression: "pagePart.elements"
                          }
                        },
                        _vm._l(pagePart.elements, function(element) {
                          return _c(
                            "div",
                            { key: element.uuid, staticClass: "element-item" },
                            [
                              _c(
                                "el-button",
                                {
                                  class: {
                                    required:
                                      element.isRequire ||
                                      element.isDefaultRequire
                                  },
                                  attrs: {
                                    title: _vm.getElementFullPath(element),
                                    disabled: _vm.isRevision
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleElementClick(element)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getElementName(element)))]
                              ),
                              _c("el-button", {
                                staticClass: "remove-element",
                                attrs: {
                                  type: "text",
                                  icon: "el-icon-close",
                                  disabled: _vm.isRevision
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeElement(pagePart, element)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm.elementConfigVisible
        ? _c("ai-custom-page-element-config", {
            attrs: {
              visible: _vm.elementConfigVisible,
              element: _vm.currentElement
            },
            on: {
              "update:visible": function($event) {
                _vm.elementConfigVisible = $event
              },
              confirm: _vm.handleElementConfigConfirm
            }
          })
        : _vm._e(),
      _vm.pagePartConfigVisible
        ? _c("ai-custom-page-page-part-config", {
            attrs: {
              visible: _vm.pagePartConfigVisible,
              "page-part": _vm.currentPagePart,
              "is-create-page-part": _vm.isCreatePagePart,
              "application-scene": _vm.applicationScene,
              "business-type": _vm.businessType
            },
            on: {
              "update:visible": function($event) {
                _vm.pagePartConfigVisible = $event
              },
              confirm: _vm.handlePagePartConfigConfirm,
              "remove-page-part": _vm.removePagePart
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }